let mobileMenuOpen = false;
$("#mobile-menu-bt").click(() => {
  toggleMobileMenu();
});
function toggleMobileMenu() {
  if (mobileMenuOpen) {
    // close mobile menu
    $("#mobile-menu").removeAttr("style");
    $("body").removeAttr("style");
    mobileMenuOpen = false;
    $("#mobile-menu-bt").removeClass("mobile-close");
    $("#mobile-menu-bt").addClass("mobile-open");
  } else {
    // open mobile menu
    $("#mobile-menu").css("display", "flex");
    mobileMenuOpen = true;
    $("#mobile-menu-bt").removeClass("mobile-open");
    $("#mobile-menu-bt").addClass("mobile-close");
    $("body").css("overflow", "hidden");
  }
}
document.getElementById("mobile-menu").addEventListener(
  "touchmove",
  e => {
    e.preventDefault();
  },
  false
);

function headerStick() {
  if ($(window).width() > 960) {
    let wTop = $(window).scrollTop();
    let staticHeaderBottom =
      $("#header-static").offset().top + $("#header-static").height();
    if (wTop > staticHeaderBottom) {
      // console.log('show');
      $("#header-sticky").css("top", "0");
      document.getElementById('header-sticky').style.top = '0';
    } else {
      // console.log('hide');
      document.getElementById('header-sticky').style.top = '-100px';
    }
  }
}

$(window).scroll(() => {
  // on scroll
  headerStick();
});

function popupOpen(e) {
  // e.preventDefault();
  document.getElementById('popup-container').style.height = '100%';
  document.getElementById('popup-close').style.display = 'block';

  if ($(window).width() > 640) {
    $("body").css("overflow", "hidden");
  }
}
function popupClose() {
  //close popup
  $("#popup-container").removeAttr("style");
  $("#popup-content").html("");
  $("#popup-close").removeAttr("style");
  $("body").css("overflow", "visible");
}
function formatTitle(el, shopPage = false) {
  let re = /\w+/g;
  let arr = el.innerHTML.toUpperCase().match(re);
  let html, startPos;
  let style = window.getComputedStyle(el);
  let fontSize = style.getPropertyValue("font-size");
  fontSize = Number(fontSize.replace("px", ""));
  let subFontSize = shopPage ? 10 : Math.round(fontSize * 0.41);
  if (subFontSize < 8) {
    subFontSize = 8;
  }

  if (arr[0] != "EXTRA") {
    html = `<span class="product-name-sub" style="font-size: ${subFontSize}px;">
      ${arr[0]} ${arr[1]}
    </span><br>`;
    startPos = 2;
  } else {
    html = `<span class="product-name-sub" style="font-size: ${subFontSize}px;">
      ${arr[0]}
    </span><br>`;
    startPos = 1;
  }
  for (let i = startPos; i < arr.length; i++) {
    html += `${arr[i]} `;
  }
  el.innerHTML = html;
}
/*function tutorialVideoUrl() {
  let text = document.getElementById("tutorials-single__text").innerHTML;
  let re = /https[^<]*vimeo\.com[^<]*\/\d\d\d\d\d\d+/gi;
  let reNum = /\/\d\d\d\d\d\d+/gi;
  let vimeoUrl = text.match(re);
  if (vimeoUrl[0]) {
    let vimeoNum = vimeoUrl[0].match(reNum);
    //console.log(vimeoNum[0]);
    //let newText = text.replace("<p>"+vimeoUrl[0]+"</p>", "");
    //document.getElementById('tutorials-single__text').innerHTML = newText;
  }
}*/
/*function tutorialVideoUrl() {
  let text = document.getElementById('tutorials-single__text').innerHTML;
  let re = /https[^<]*vimeo\.com[^<]*\/\d\d\d\d\d\d+/gi;
  let reNum = /\d\d\d\d\d\d+/gi;
  let vimeoUrl = text.match(re);
  if(vimeoUrl[0]){
    let vimeoNum = vimeoUrl[0].match(reNum);
    console.log(vimeoNum[0]);
    let newText = text.replace("<p>"+vimeoUrl[0]+"</p>", "");
    newText = newText.replace("<p><span>"+vimeoUrl[0]+"</span></p>", "");
    document.getElementById('tutorials-single__text').innerHTML = newText;
    vimeoIframeHtml = `<iframe src="https://player.vimeo.com/video/${vimeoNum}?autoplay=1&title=0&byline=0&portrait=0" width="414" height="233" frameborder="0" allowfullscreen></iframe>`;
  }
}*/
function formatPrice(price) {
  price = price * 0.01;
  price = price.toFixed(2);
  return "$" + price;
}
function formatRelatedProductNames() {
  let className = "product-related-products-product-name";
  let names = document.getElementsByClassName(className);
  for (let name of names) {
    formatTitle(name);
  }
}
function formatProductNamesByClass(className, shopPage = false) {
  let names = document.getElementsByClassName(className);
  for (let name of names) {
    formatTitle(name, shopPage);
  }
}
if(document.getElementById('home-tutorials-carousel')){
  $("#home-tutorials-carousel").slick({
    accessibility: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    appendArrows: $('#tutorials-arrows'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
if(document.getElementById('home-hairgoals-carousel')){
  $("#home-hairgoals-carousel").slick({
    accessibility: false,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    appendArrows: $('#hairgoals-arrows'),
    responsive: [
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 912,
        settings: {
          slidesToShow: 3,
          slidesToScroll:3
        }
      },
      {
        breakpoint: 684,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 456,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
/*
let shopBt = document.getElementById('shop-bt'); 
let shopSubMenu = document.getElementById('shopSubMenu'); 
shopBt.addEventListener("mouseenter", (e) => {   
  openShopSubMenu();
});
shopSubMenu.addEventListener("mouseenter", (e) => {   
  openShopSubMenu();
});
shopBt.addEventListener("mouseleave", (e) => {   
  closeShopSubMenu();
});
shopSubMenu.addEventListener("mouseleave", (e) => {   
  closeShopSubMenu();
});
function openShopSubMenu () {
  shopSubMenu.style.opacity = '1';
  shopSubMenu.style.height = 'auto';
  shopSubMenu.style.marginTop = '0px';
  shopSubMenu.style.left = shopBt.getBoundingClientRect().x + 'px';
  console.log('open')
}
function closeShopSubMenu () {
  shopSubMenu.style.opacity = '0';
  shopSubMenu.style.marginTop = '10px';
  setTimeout(()=>{
    shopSubMenu.style.height = '0px';
  }, 200);
  console.log('close')
}
*/

/*
let shopBt = document.getElementById('shop-bt'); 
let shopSubMenu = document.getElementById('shopSubMenuList'); 
shopBt.addEventListener("mouseenter", (e) => {   
  openShopSubMenu();
});
shopBt.addEventListener("mouseleave", (e) => {   
  closeShopSubMenu();
});
function openShopSubMenu () {
  shopSubMenu.style.opacity = '1';
  shopSubMenu.style.height = 'auto';
  shopSubMenu.style.marginTop = '0px';
  console.log('open')
}
function closeShopSubMenu () {
  shopSubMenu.style.opacity = '0';
  setTimeout(()=>{
    shopSubMenu.style.height = '0px';
    shopSubMenu.style.marginTop = '10px';
  }, 200);
  console.log('close')
}
*/
function openShopSubMenu (shopBt) {
  let shopSubMenu = shopBt.children[1]; 
  shopSubMenu.style.left = 'auto';
  shopSubMenu.style.opacity = '1';
  shopSubMenu.style.height = 'auto';
  shopSubMenu.style.marginTop = '0px';
  console.log('open')
}
function closeShopSubMenu (shopBt) {
  let shopSubMenu = shopBt.children[1]; 
  shopSubMenu.style.opacity = '0';
  setTimeout(()=>{
    shopSubMenu.style.height = '0px';
    shopSubMenu.style.marginTop = '10px';
    shopSubMenu.style.left = '-9000px';
  }, 250);
  console.log('close')
}
for( let shopBt of Array.from(document.getElementsByClassName('shop-bt'))){
  shopBt.addEventListener("mouseenter", (e) => {   
    openShopSubMenu(shopBt);
  });
  shopBt.addEventListener("mouseleave", (e) => {   
    closeShopSubMenu(shopBt);
  });
}